import { PaymentState } from "@/data/model/Enums";

import { trans } from "@/operator/localization/Trans";

export class PaymentStateBadge {
    public static renderTo($parent: JQuery, paymentState: PaymentState) {
        $(this.render(paymentState)).appendTo($parent);
    }

    public static render(paymentState: PaymentState) {
        const state = PaymentState[paymentState];
        return `<span class="payment-state-badge payment-state-${state.toLowerCase()}">${
            trans.enums.paymentState[state]
        }</span>`;
    }
}
